import React from 'react';
import { makeStyles } from "@material-ui/core/styles";

import { Button, Dialog, DialogTitle, DialogContent, TextField as TextFieldMaterial, DialogActions } from "@material-ui/core"

import { SimpleForm, FileInput, FileField, useMutation, useNotify, useRefresh } from 'react-admin';


const useStyles = makeStyles((theme) => ({
    rootContent: {

    },
}));

const DialogComponent = (props) => {
    const notify = useNotify();
    const classes = useStyles();
    const refresh = useRefresh()
    const { maxWidth = "md", product = {}, record = {}, id, classesContent = {}, handleClose, title, children, ...rest } = props;
    const [products, setProducts] = React.useState([]); // State to hold the products

    const [handleEdit] = useMutation(
        {
            type: 'update',
            resource: 'warehouseagencies',
        },
        {
            undoable: false,
        }
    );
    const handleSubmit = async () => {
        try {
            await Promise.all(
                products.map((product) =>
                    handleEdit({ payload: { data: product } })
                )
            );
            notify('Prices updated successfully', 'success');
            setTimeout(() => {
                refresh();
                handleClose();
            }, 2000); // Wait for the mutations to complete before refreshing
        } catch (error) {
            notify(`Error: ${error.message}`, 'error');
        }
    };


    const handleChange = (values) => {
        setProducts([]);
        if (values) {
            if (values.size > 1 * 1024 * 1024) {
                notify("File is too big");
                return;
            }
            var reader = new FileReader();
            reader.onload = function(e) {
                let value = (reader.result.split("\n") || [])
                    .slice(1)
                    .map((e) => {
                        let [product_id, _, price] = e.split(",");
                        console.log(e);
                        return {
                            sale_price: Number(price), product_id: product_id, agency_id: id
                        };
                    });
                setProducts(value);

            };
            reader.readAsText(values);
        }
    };


    return (
        <Dialog {...rest} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{title}</DialogTitle>
            <DialogContent classes={{
                ...classesContent,
                root: classes.rootContent,
            }} maxWidth={maxWidth}>

                <SimpleForm {...props} toolbar={null} >
                    <FileInput
                        source="files"
                        label="Upload File"
                        onChange={handleChange}
                    >
                        <FileField source="src" title="title" />
                    </FileInput>

                </SimpleForm>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" onClick={handleSubmit}>Save</Button>
                <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogComponent;
